// Keep the document's issue date; converting timezones can change its calendar day.
export const fulfillmentFilename = (fulfillment, format) => {
  const clean = value => Array.from(String(value ?? '').replace(/[<>:"/\\|?*\u0000-\u001f\u007f]/g, '-').replace(/\s+/g, ' ').trim().replace(/[. ]+$/g, '')).slice(0, 45).join('');
  const parts = [
    'TIG',
    clean(fulfillment.partner?.name) || 'Partner',
    clean(fulfillment.name) || 'Teljesítés',
    clean(fulfillment.issue_date?.slice(0, 10)) || 'Dátum nélkül',
    clean(fulfillment.serial ?? fulfillment.id),
  ];
  return `${parts.filter(Boolean).join(' - ')}.${format}`;
};
